<template>
  <div id="app">
    <HeaderCompo
      :big-header="bigHeader"
    />
    <template v-if="actualView === 'loading'">
      <b-loading
        is-full-page
        :active.sync="isLoading"
      >
        <div class="box loading">
          <div class="bloader">
            <div class="shape shape-1" />
            <div class="shape shape-2" />
            <div class="shape shape-3" />
            <div class="shape shape-4" />
          </div>
        </div>
      </b-loading>
    </template>
    <section
      id="content"
      class="section"
    >
      <RegisterCompo
        v-if="actualView === 'register'"
        :user-id="userId"
        :has-user="hasUser"
        @headerEvent="headerEventFired"
      />
    </section>
    <FlyCompo />
    <FooterCompo
      :where-at="whereAt"
    />
    <!-- 728x90 sticky footer Desktop Only -->
    <!-- <div id="waldo-tag-15164" /> -->
  </div>
</template>

<script>
import HeaderCompo from '@/components/HeaderCompo.vue'
import FooterCompo from '@/components/FooterCompo.vue'
import RegisterCompo from '@/components/RegisterCompo.vue'
import FlyCompo from '@/components/FlyCompo.vue'
import firebase from 'firebase/app'
import 'firebase/auth'

export default {
  name: 'Home',
  components: {
    HeaderCompo,
    FooterCompo,
    RegisterCompo,
    FlyCompo
  },
  data () {
    return {
      userId: null,
      hasUser: false,
      actualView: 'loading',
      bigHeader: true,
      isLoading: true,
      whereAt: 'at-home'
    }
  },
  created: function () {
    const that = this
    firebase.auth().signInAnonymously().catch(function (err) {
      // eslint-disable-next-line
      let errCode = err.code
      // eslint-disable-next-line
      let errMessage = err.message
    })
    firebase.auth().onAuthStateChanged(function (user) {
      if (user) {
        let isAnon = user.isAnonymous
        if (isAnon) {
          // eslint-disable-next-line
          let anonymousUser = user
        }
        let userID = user.uid
        that.userId = userID
        // console.log(that.userId)

        firebase.auth().currentUser.getIdToken(/* forceRefresh */ true).then(function(idToken) {
          // Send token to your backend via HTTPS
            // console.log(idToken)
          that.$http.defaults.headers.common = {'Authorization': `Bearer ${idToken}`}

          //               GO
          that.$http.get('https://bestiebackend.herokuapp.com/api/users/' + userID)
            .then(response => {
              if (response.data.user !== null) {
                that.hasUser = true
                if (response.data.user.quiz_created_id) {
                  window.location.href = '/q?=' + response.data.user.quiz_created_id
                  // has quiz saved so redirected
                } else {
                  that.actualView = 'register'
                  that.isLoading = false
                  // has user but not quiz saved
                }
              } else {
                that.actualView = 'register'
                that.isLoading = false
                // dont have user saved
              }
            })
            .catch(error => {
              // console.log(error)
            })
            
        }).catch(function(error) {
          // firebase getIdToken call
        });
            
      } else {}
    })
  },
  methods: {
    headerEventFired (value) {
      this.bigHeader = value
    }
  }
}
</script>

<style scoped>
</style>
